import { Button } from '@blueprintjs/core';
import { getObjectStatus, OBJECT_STATUS } from 'Data/Enum';
import PropTypes from 'prop-types';
import styles from './StatusButton.module.css';

const StatusButton = ({
  statusKey,
  onStatusButtonClicked,
  disabled = false,
  icon,
  hideLabel = false,
}) => {
  let statusObject = getObjectStatus(statusKey);
  let styleClass = statusObject?.key
    ? `${statusObject.key.toLowerCase()}_status`
    : '';

  return (
    <Button
      minimal
      icon={icon || (statusObject === OBJECT_STATUS.DEACTIVATED && 'disable')}
      className={`${styles[styleClass]} ${disabled ? styles.disabled : ''} `}
      style={!onStatusButtonClicked && { pointerEvents: 'none' }}
      disabled={disabled}
      onClick={() => onStatusButtonClicked && onStatusButtonClicked()}>
      {!hideLabel && (
        <div
          style={{
            width: '100%',
            justifyContent: 'center',
          }}>
          {statusObject?.label || statusKey}
        </div>
      )}
    </Button>
  );
};

StatusButton.propTypes = {
  statusKey: PropTypes.string,
  onStatusButtonClicked: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  hideLabel: PropTypes.bool,
};

export default StatusButton;
